<template>
  <div class="equipment-container">
    <!-- 左侧文字列 -->
    <div class="text-column left-text">
      <div class="top-text">18XX</div>
      <div class="text-item">1.8m</div>
    </div>

    <!-- 第一台设备图片 -->
    <div class="image-column">
      <img style="height: 500px"
          src="../../static/series/evo/length1.png"
          class="equipment-image left-length-image"
      >
    </div>

    <!-- 第二台设备图片 -->
    <div class="image-column" style="z-index: 1">
      <img
          src="../../static/series/evo/length2.png"
          class="equipment-image right-length-image"
      >
    </div>

    <!-- 右侧文字列 -->
    <div class="text-column right-text">
      <div class="top-text">25XX</div>
      <div class="text-item">2.5m</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EquipmentComparison',
  data() {
    return {
      isMobile: false,
      scaleRatio: 1
    }
  },
  methods: {
    checkDevice() {
      this.isMobile = window.innerWidth <= 768;
      // 计算缩放比例（手机端基于屏幕宽度动态调整）
      this.scaleRatio = this.isMobile ? Math.min(window.innerWidth / 1000, 0.7) : 1;
    },
    handleResize() {
      this.checkDevice();
    }
  },
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.handleResize);

    this.$nextTick(() => {
      // 基于缩放比例的动画参数
      const animParams = {
        textXLeft: 100 * this.scaleRatio,
        textXRight: -150 * this.scaleRatio,
        imgXLeft: 200 * this.scaleRatio,
        imgXRight: -150 * this.scaleRatio,
        yOffset: 50 * this.scaleRatio,
        exitY: -300 * this.scaleRatio,
        duration: 2 * this.scaleRatio,
        scrub: this.isMobile ? 1 * this.scaleRatio : 1
      }

      this.$gsap.set(['.top-text', '.text-item'], {
        color: "#1d1d1f",
      })

      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: ['.left-text'],
          start: this.isMobile ? 'top 90%' : 'top 85%',
          end: this.isMobile ? 'bottom 30%' : 'bottom 20%',
          markers: false,
          delay: this.isMobile ? 0.5 : 1,
          scrub: animParams.scrub,
          toggleActions: 'play none none reverse'
        }
      })

      masterTimeline
          .from(['.top-text', '.text-item'], {
            color: "#808080",
            duration: animParams.duration,
          }, 0)
          .from(['.left-text'], {
            x: animParams.textXLeft,
            y: animParams.yOffset,
            duration: animParams.duration,
            ease: 'power2.out'
          }, 0)
          .from(['.left-length-image'], {
            x: animParams.imgXLeft,
            y: animParams.yOffset,
            duration: animParams.duration,
            ease: 'power2.out'
          }, 0)
          .from(['.right-text'], {
            x: animParams.textXRight,
            y: animParams.yOffset,
            duration: animParams.duration,
            ease: 'power2.out'
          }, 0)
          .from(['.right-length-image'], {
            x: animParams.imgXRight,
            y: animParams.yOffset,
            duration: animParams.duration,
            ease: 'power2.out'
          }, 0)
          .to(['.equipment-container'], {
            y: animParams.exitY,
            duration: 2.5 * this.scaleRatio,
            ease: 'power2.out'
          })
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style scoped>
.equipment-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  height: 700px; /* 固定高度确保布局稳定 */
}

.text-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
  width: 100px;
}

.left-text {
  align-items: flex-end;
}

.right-text {
  align-items: flex-start;
}

.text-item {
  font-size: 2.5em;
  margin: 10px 0;
  color: #333;
  white-space: nowrap; /* 防止文字换行 */
}

.top-text {
  padding-top: 10px;
  border-top: 2px solid #333;
}

.image-column {
  margin: 0 15px;
}

.equipment-image {
  max-height: 600px;
  width: auto;
  object-fit: contain;
  border-radius: 4px;
}

/* 手机端适配 - 保持横向排版，按比例缩小 */
@media (max-width: 768px) {
  .equipment-container {
    height: calc(700px * 0.7); /* 按比例缩小高度 */
    padding: 10px;
    overflow-x: auto; /* 允许横向滚动以防溢出 */
    scrollbar-width: none; /* 隐藏滚动条 */
  }

  .equipment-container::-webkit-scrollbar {
    display: none; /* 隐藏滚动条 */
  }

  .text-column {
    width: calc(100px * 0.7); /* 文字列宽度按比例缩小 */
    padding: 0 calc(20px * 0.7);
  }

  .text-item {
    font-size: calc(2.5em * 0.7); /* 文字大小按比例缩小 */
    margin: calc(10px * 0.7) 0;
  }

  .top-text {
    padding-top: calc(10px * 0.7);
    border-top-width: calc(2px * 0.7); /* 线条粗细按比例缩小 */
    font-size: calc(1em * 0.7);
  }

  .image-column {
    margin: 0 calc(15px * 0.7); /* 图片间距按比例缩小 */
  }

  .equipment-image {
    max-height: calc(600px * 0.7); /* 图片高度按比例缩小 */
  }

  /* 左侧图片固定宽度按比例缩小 */
  .left-length-image {
    width: calc(275px * 0.7) !important;
  }
}

/* 小屏手机进一步微调 */
@media (max-width: 480px) {
  .equipment-container {
    height: calc(700px * 0.6);
  }

  .text-column {
    width: calc(100px * 0.6);
  }

  .text-item {
    font-size: calc(2.5em * 0.6);
  }

  .equipment-image {
    max-height: calc(600px * 0.6);
  }

  .left-length-image {
    width: calc(275px * 0.6) !important;
  }
}
</style>
